import { useState } from 'react'

const PLATFORM_OPTIONS = [
  { value: 'ios', label: 'iOS' },
  { value: 'android', label: 'Android' },
]

function normalizePlatformForForm(platform) {
  if (platform === undefined || platform === null) return ''
  if (platform === 'ios' || platform === 'android') return platform
  const n = Number(platform)
  if (n === 1) return 'android'
  if (n === 2) return 'ios'
  return ''
}

const EMPTY_FORM = {
  name: '',
  platform: '',
  bundleId: '',
  iconFile: null,
}

export default function ApplicationForm({
  initialValues,
  onSubmit,
  submitLabel,
  isSubmitting = false,
  error = null,
  disabled = false,
}) {
  const isReadOnly = disabled
  const [values, setValues] = useState(() => {
    const platform = normalizePlatformForForm(initialValues?.platform)
    return {
      ...EMPTY_FORM,
      name: initialValues?.name || '',
      platform: platform || 'android',
      bundleId: initialValues?.bundleId || '',
      iconFile: null,
    }
  })

  function handleChange(event) {
    const { name, value } = event.target
    setValues((previousValues) => ({
      ...previousValues,
      [name]: value,
    }))
  }

  function handleIconChange(event) {
    const [file] = event.target.files || []
    setValues((previousValues) => ({
      ...previousValues,
      iconFile: file || null,
    }))
  }

  function handlePlatformSelect(platform) {
    setValues((previousValues) => ({
      ...previousValues,
      platform,
    }))
  }

  function handleSubmit(event) {
    event.preventDefault()
    onSubmit(values)
  }

  return (
    <form className="card formCard" onSubmit={handleSubmit}>
      <div className="cardTitle">Application</div>

      <div className="formGrid">
        <label className="formField">
          <span className="formLabel">Name</span>
          <input
            className="textInput"
            name="name"
            value={values.name}
            onChange={handleChange}
            placeholder="ExampleApp"
            required
            disabled={isSubmitting || isReadOnly}
          />
        </label>

        <label className="formField">
          <span className="formLabel">Platform</span>
          <div className="platformSelector" role="radiogroup" aria-label="Platform">
            {PLATFORM_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                type="button"
                className={`platformSelectorOption ${values.platform === opt.value ? 'platformSelectorOptionActive' : ''}`}
                onClick={() => handlePlatformSelect(opt.value)}
                aria-pressed={values.platform === opt.value}
                disabled={isSubmitting || isReadOnly}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </label>

        <label className="formField">
          <span className="formLabel">Bundle ID</span>
          <input
            className="textInput"
            name="bundleId"
            value={values.bundleId}
            onChange={handleChange}
            placeholder="com.example.app"
            required
            disabled={isSubmitting || isReadOnly}
          />
        </label>

        {!isReadOnly ? (
          <div className="formField">
            <span className="formLabel">Icon file (optional)</span>
            <div className="appIconUploadControl">
              <label className="button buttonGhost appIconUploadButton">
                <span>{values.iconFile ? 'Choose another file' : 'Choose file'}</span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleIconChange}
                  disabled={isSubmitting}
                  className="appIconUploadInput"
                />
              </label>
              <span className="appIconUploadFileName">
                {values.iconFile?.name || 'No file selected'}
              </span>
            </div>
          </div>
        ) : null}

        {initialValues?.icon ? (
          <div className="formField">
            <span className="formLabel">{isReadOnly ? 'Icon' : 'Current icon'}</span>
            <a href={initialValues.icon} target="_blank" rel="noreferrer" className="applicationFormIconWrap">
              <img src={initialValues.icon} alt="Application icon" className="applicationHeaderIcon" width="96" height="96" />
            </a>
          </div>
        ) : null}
      </div>

      {error ? <div className="formError">{String(error.message || error)}</div> : null}

      {!isReadOnly ? (
        <div className="formActions">
          <button className="button buttonPrimary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : submitLabel}
          </button>
        </div>
      ) : null}
    </form>
  )
}
